var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col-md-4 left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.configuration")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.notifications")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [_c("channel-notification", { attrs: { app_id: 3, code: ["300"] } })],
        1
      ),
      _vm._v(" "),
      _c("BaseModalOverLimit", {
        attrs: {
          id: _vm.modalFeeAlert,
          headerText: _vm.$t("overlimit.linemessage.header"),
          bodyTextUnitPrice: _vm.$t("overlimit.linemessage.body.unitprice", {
            number: _vm.getCurrencyWithNumber(
              _vm.numberel(_vm.pricing.messageLine, "0,0.[000000]")
            )
          }),
          bodyTextPerMonth: _vm.$t("overlimit.linemessage.body.permonth", {
            number: _vm.numberel(_vm.shopUseLimit.messageLine, "0,0")
          })
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3e0bc98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3e0bc98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/configuration/Notification.vue
// module id = null
// module chunks = 